import {parseInteger} from '@benchling/js-utils';
import React from 'react';

import {Label} from 'bulk-workflows/BulkWorkflowComponents';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import {InputChangeEvent} from 'util/Types';

import * as BulkTranslationActions from '../BulkTranslationActions';
import {TranslationSpec} from '../BulkTranslationConstants';

interface Props {
  translationSpec: TranslationSpec;
  translationSpecIndex: number;
}

function TranslationSpecEditor(props: Props): JSX.Element {
  const {translationSpec} = props;

  const _handleFirstCodonAnnotationNameChange = (e: InputChangeEvent): void => {
    BulkTranslationActions.updateTranslationSpec(props.translationSpecIndex, {
      firstCodonAnnotationName: e.target.value,
    });
  };

  const _handleFirstCodonOffsetChange = (e: InputChangeEvent): void => {
    BulkTranslationActions.updateTranslationSpec(props.translationSpecIndex, {
      firstCodonOffset: parseInteger(e.target.value),
    });
  };

  return (
    <div>
      <Label>{translationSpec.tagSchemaField.name}</Label>
      <FormGroup>
        <Label allCaps={true} className="bulkWorkflow-tag-name">
          First codon annotation
        </Label>
        <FormInput
          type="text"
          value={translationSpec.firstCodonAnnotationName}
          onChange={_handleFirstCodonAnnotationNameChange}
        />
      </FormGroup>
      <FormGroup>
        <Label allCaps={true} className="bulkWorkflow-tag-name">
          Offset from annotation start
        </Label>
        <FormInput
          type="number"
          value={translationSpec.firstCodonOffset ?? undefined}
          onChange={_handleFirstCodonOffsetChange}
        />
      </FormGroup>
    </div>
  );
}

export default TranslationSpecEditor;
